import {ROUTE_ADD_HELP_SECTION, ROUTE_EDIT_HELP_SECTION, ROUTE_HELP_SECTION, ROUTE_VIEW_HELP_SECTION, ROUTE_VIEW_USER_HELP_SECTION, ROUTE_VIEW_USER_HELP_SECTION_DOCUMENT} from '../../RoutePathConstant';
import {authLoader} from '../../loader';
import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';

const HelpSection = lazy(() =>
  import('../../../screens/HelpSection')
    .then(module => ({default: module.HelpSection})));

const AddHelpSection = lazy(() =>
  import('../../../screens/HelpSection')
    .then(module => ({default: module.CreateHelpSection})));

const EditHelpSection = lazy(() =>
  import('../../../screens/HelpSection')
    .then(module => ({default: module.UpdateHelpSection})));

const ViewHelpSection = lazy(() =>
  import('../../../screens/HelpSection')
    .then(module => ({default: module.ViewHelpSections})));

const ViewUserHelpSection = lazy(() =>
  import('../../../screens/HelpSection')
    .then(module => ({default: module.ViewUserHelpSubSection})));

const ViewUserHelpSubSectionDocument = lazy(() =>
  import('../../../screens/HelpSection')
    .then(module => ({default: module.ViewHelpSubsectionDocument})));

const HelpSectionNavigation = [
  {
    path: ROUTE_HELP_SECTION,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <HelpSection />
      </Suspense>
    ),
  },
  {
    path: ROUTE_ADD_HELP_SECTION,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <AddHelpSection />
      </Suspense>
    ),
  },
  {
    path: ROUTE_EDIT_HELP_SECTION,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <EditHelpSection />
      </Suspense>
    ),
  },
  {
    path: ROUTE_VIEW_HELP_SECTION,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <ViewHelpSection />
      </Suspense>
    ),
  },
  {
    path: ROUTE_VIEW_USER_HELP_SECTION,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <ViewUserHelpSection />
      </Suspense>
    ),
  },
  {
    path: ROUTE_VIEW_USER_HELP_SECTION_DOCUMENT,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <ViewUserHelpSubSectionDocument />
      </Suspense>
    ),
  },
];

export default HelpSectionNavigation;
